export const URLS = {
  // Live
  // baseApi: 'https://api.bad-kursmanager.de/api/admin/',
  // baseApiLecturer: 'https://api.bad-kursmanager.de/api/lecturer/',

  // Staging
  // baseApi: 'https://api.akademio-digital.de/api/admin/',
  // baseApiLecturer: 'https://api.akademio-digital.de/api/lecturer/',

  //  Local
  // baseApi: 'http://192.168.31.248:3000/api/admin/',
  // baseApiLecturer: 'http://192.168.31.248:3000/api/lecturer/',

  // MAB
  baseApi: "https://api.mab.akademio-digital.de/api/admin/",
  baseApiLecturer: "https://api.mab.akademio-digital.de/api/lecturer",
};
